import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "../../../styles/admin_user_nav.css";
import dayjs from "dayjs";
import label from "../../labels/accessRightsManagement_en.json";
import clabel from "../../../common/labels/common_en.json";
import { UserApprovalEntity } from "../../actions/accessRightsManagementActions";

const UserRegistrationEntity = (props) => {
  let [selectedEntity, setSelectedEntity] = useState();
  const [action,setAction]=useState("");
  const { register, handleSubmit, formState, watch } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.setSelectedApprovalEntity) {
      setSelectedEntity(props.setSelectedApprovalEntity);
    }
  }, [props.setSelectedApprovalEntity]);

  useEffect(() => {
    if (selectedEntity) {
      const entityId = selectedEntity.userApproval.id;
      // dispatch(AbsentListObjApprovalEntityRequest(entityId));
    }
  }, [dispatch, selectedEntity]);

  //   useEffect(() => {

  //     if (
  //       props.setSelectedApprovalEntity &&
  //       props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
  //         .detail
  //     ) {
  //       setAllAnswerValues(
  //         props.setSelectedApprovalEntity.entityApprovalAction.entityApprovalDto
  //           .detail
  //       );
  //     }
  //   }, [selectedEntity]);

  const onStatus=(value)=>{
    setAction(value)
  }
  const onSubmit = (data) => {

    let requestData = selectedEntity;
    requestData.userApproval.action = data.statustype;
    requestData.lastApproverComments = data.comment.trim();
    let requestBody = {
      userApprovalId: requestData.userApproval.id,
      action: action,
      comments: requestData.lastApproverComments,
    };

    dispatch(UserApprovalEntity(requestBody, props.setShowModal));
    setSelectedEntity(selectedEntity);
  };

  return (
    <Modal
      size="xl"
      show={props.showModal}
      onHide={() => {
        props.setShowModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-xl"
      backdrop="static"
    >
      <form>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-xl">
            {selectedEntity && selectedEntity.userApproval.approvalType}(
            {selectedEntity && selectedEntity.userApproval.status
              ? label.Approval1Pending
              : ""}
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-8">
              {selectedEntity && selectedEntity ? (
                <div className="VenueSection">
                  <div className="row custom-padding">
                    <table className="table table-bordered text-center border border-dark">
                      {/* <tbody>
        {selectedEntity &&
            <tr key={index}>
                <td className='text-left'>{item.label}</td>
                <td className='w-30'>{item.data}</td>
            </tr>
        }
    </tbody> */}
                      <tbody>
                        {selectedEntity && (
                          <>
                            <tr>
                              <td >{label.Status}</td>
                              <td className="w-35">
                                {selectedEntity &&
                                  selectedEntity.userApproval.status}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.UpdatedOn}</td>
                              <td className="w-35">
                                {" "}
                                {selectedEntity.updatedOn
                                  ? dayjs(selectedEntity.updatedOn).format(
                                    "DD/MM/YYYY h:mm A"
                                  )
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.firstName}</td>
                              <td className="w-35">
                                {selectedEntity.userApproval.firstName}
                              </td>
                            </tr>
                            <tr>
                              <td>{label.lastName}</td>
                              <td className="w-35">
                                {selectedEntity.userApproval.lastName}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.UserEmailId}</td>
                              <td className="w-35">
                                {selectedEntity.userApproval.email}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.Usermobile}</td>
                              <td className="w-35">
                                {selectedEntity.userApproval.mobile}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.Role}</td>
                              <td className="w-35">
                                {selectedEntity.roleName}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.Department}</td>
                              <td className="w-35">
                                {selectedEntity.departmentName}
                              </td>
                            </tr>
                            <tr>
                              <td >{label.Approver}</td>
                              <td className="w-35">
                                {selectedEntity.lastApprover}
                              </td>
                            </tr>
                            <tr>
                              <td >
                                {label.CommentsByApprover}
                              </td>
                              <td className="w-35">
                                {selectedEntity.lastApproverComments}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
              <hr></hr>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-header">
                  {label.Approval} (
                  {selectedEntity && selectedEntity.userApproval.status
                    ? label.Approval1Pending
                    : ""}
                  {/* {selectedEntity &&
                  selectedEntity.entityApprovalAction.level == 2
                    ? label.APPROVAL_LEVEL_2_PENDING
                    : ""}
                  {selectedEntity &&
                  selectedEntity.entityApprovalAction.level == 3
                    ? label.APPROVAL_LEVEL_3_PENDING
                    : ""} */}
                  )
                </div>
                <div
                  className={`card-body ${selectedEntity &&
                    selectedEntity.userApproval.status == "Approved"
                    ? "disabled-link"
                    : ""
                    }`}
                >
                  <label className="bold-label">{label.Action}</label>
                  &nbsp;&nbsp;
                  <h6>
                    {selectedEntity && selectedEntity.userApproval.approvalType}
                  </h6>
                  <br />
                  <h6 className="bold-label">
                    {label.Status}
                    <span className="redColor">*</span>
                  </h6>
                  <div className="col-md-12 radio-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        className="radio"
                        name="statustype"
                        value="1"
                        onChange={()=>onStatus('accept')}
                        ref={register({ required: true })}
                      />
                      &nbsp;{label.Approve}
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        className="radio"
                        name="statustype"
                        value="2"
                        onChange={()=>onStatus('reject')}
                        ref={register({ required: true })}
                      />
                      &nbsp;{label.Reject}
                    </label>
                  </div>
                  {watch("statustype") == "2" ? (
                    <>
                      <h6 className="bold-label">
                        {label.Comments}
                        <span className="redColor">*</span>
                      </h6>
                      <div className="top-padding">
                        <h6>
                          <input
                            type="text"
                            className="form-control"
                            name="comment"
                            maxLength={255}
                            placeholder={clabel.ENTER_TEXT_UPTO_255_CHARACTERS}
                            ref={register({
                              required: true,
                              pattern: {
                                value: /^(?!\s+$)/,
                              },
                            })}
                          />
                        </h6>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="top-padding">
                        <h6 className="bold-label">{label.Comments}</h6>
                        <h6>
                          <input
                            type="text"
                            className="form-control"
                            name="comment"
                            maxLength={255}
                            placeholder={clabel.ENTER_TEXT_UPTO_255_CHARACTERS}
                            ref={register({
                              required: false,
                              pattern: {
                                value: /^(?!\s+$)/,
                              },
                            })}
                          />
                        </h6>
                      </div>
                    </>
                  )}
                  <div className="row custom-button justify-content-end">
                    <button
                      className="btn btn-secondary mr-2"
                      type="button"
                      onClick={() => {
                        props.setShowModal(false);
                      }}
                    >
                      {label.Cancel}
                    </button>
                    <button
                      className="btn btn-primary mr-2"
                      disabled={!formState.isValid}
                      onClick={handleSubmit((e) => {
                        onSubmit(e);
                      })}
                    >
                      {label.Save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
};
export default UserRegistrationEntity;
